export default {
  hasSalary (job) {
    if ((job.salaryMax && job.salaryMin) || job.salaryMin || job.salaryMax) {
      return true
    }
    return false
  },
  getSeventeenPercent (reward) {
    let donation = (parseFloat(reward) / 100)
    return (donation * 17).toFixed(2)
  },
  getHalf (reward) {
    let actualReward = parseFloat(reward) / 2
    return actualReward
  }
}

const applyHeadingStyles = (element) => {
  try {
    for (let i = 0; i < element.length; i++) {
      element[i].style.marginTop = '20px'
      element[i].style.marginBottom = '8px'
      element[i].style.fontSize = 'revert'
      element[i].style.fontWeight = 'revert'
    }
  } catch (e) {
    console.log('heading styles error', e)
  }
}

export const bbCodeJobDescriptionStyles = function (document) {
  try {
    const productAttr = document.getElementsByTagName('ul')
    const h1 = document.getElementsByTagName('h1')
    const h2 = document.getElementsByTagName('h2')
    const h3 = document.getElementsByTagName('h3')
    const h4 = document.getElementsByTagName('h4')
    const h5 = document.getElementsByTagName('h5')
    const h6 = document.getElementsByTagName('h6')

    const headings = [h1, h2, h3, h4, h5, h6]

    for (let heading = 0; heading < headings.length; heading++) {
      if (headings[heading].length > 0) {
        applyHeadingStyles(headings[heading])
      }
    }

    for (let i = 0; i < productAttr.length; i++) {
      productAttr[i].style.listStyle = 'unset'
      productAttr[i].style.paddingLeft = '24px'
      productAttr[i].style.marginBottom = '20px'
    }
  } catch (e) {
    console.log('description error', e)
  }
}



// WEBPACK FOOTER //
// ./src/helpers/job.js